import {TailSpin} from "react-loader-spinner";

export const Spinner = ({ loading }) => (
    loading ? (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
        }}>
            <TailSpin
                height="50"
                width="50"
                color="#FFFFFF"
                ariaLabel="loading"
            />
        </div>
    ) : null
);